@if (showLoading) {
    <p-skeleton></p-skeleton>
} @else if (_user) {
    {{ _user.email }}
}
